// extracted by css-extract-rspack-plugin
export default {"root":"RcG9u9","transform":"mesiRN","swipeable":"jffRlK","preview":"Vo0RTq","next":"N6m6Xm","prev":"RQZfsR"};